import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { switchMap, take } from 'rxjs/operators';
import { of } from 'rxjs';
import * as moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-shopclues-manage-store-management',
  templateUrl: './shopclues-manage-store-management.component.html',
  styleUrls: ['./shopclues-manage-store-management.component.css']
})
export class ShopcluesManageStoreManagementComponent implements OnInit {
  productImage: string = "/assets/images/default-product.png";
  deleteApiPop: string = 'N';
  editApiPop: string = 'N';
  index: any;
  syncEnabled: boolean = false;
  manualImportsOrders: boolean = false;
  manualImportsProducts: boolean = false;
  importOrders: boolean = false;
  updateOrders: boolean = false;
  uploadImage: string;
  disableStatuses = true;
  manualImports: string;
  scheduleOrders: any;
  importProducts: string;
  scheduleProducts: string;
  syncEnabledProducts: boolean = false;
  tabActive: string = '';
  dropdownList = [];
  importsdropdownList = [];
  importsFulFillmentStatusList = [];
  selectedItems: any = '';
  errorMessage: string;
  dropdownSettings: IDropdownSettings = {};
  statusText: string;
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statusText8: string;
  statusText9: string;
  statusText10: string;
  statusText11: string;
  statusText12: string;
  statusText13: string;
  statusText14: string;
  statusText15: string;
  statusText16: string;
  statusText17: string;
  statusText18: string;
  statusText19: string;
  statusText20: string;
  statusText21: string;
  statusText22: string;
  statusText23: string;
  statusText24: string;
  statusText25: string;
  statusText26: string;
  statusText27: string;
  statusText28: string;
  statusText29: string;
  statusText30: string;
  statusText31: string;
  statusText32: string;
  statusText33: string;
  statusText34: string;
  statusText35: string;
  statusText36: string;
  statusText37: string;
  statusText38: string;
  statusText39: string;
  errorStartDate = "";
  errorDuration = "";
  errorDurationType = "";
  errorSStartDate = "";
  storeManage: any = {};
  storeDetails: string = 'N'
  mId: any;
  syncId: any;
  syncProductId: any;
  scheduleStore: any = {
    syncType: "",
    startDate: "",
    endDate: "",
    duration: "",
  };
  scheduleStores: any = [];
  item_text: any;
  storeManageId: any;
  storeManagementp: string = 'N'
  storeManagement: any;
  sync: string = 'N';
  store: any = {
    syncType: "",
    syncTypeProducts: ""
  };
  magentoProducts: any;
  magentoOrders: any;
  active: any;
  tabClicked = "ORDERS";
  selectPeriodicType = "";
  selectPeriodicTypeProducts = "";
  noOfDays: number;
  noOfDaysProducts: number;
  startDate: string;
  startDateProducts: string;
  endDateProducts: string;
  endDate: string;
  syncImport: string;
  imageUrl: any;
  syncUpdateOrder: string;
  startDateError: string;
  startDateErrorProducts: string;
  endDateErrorProducts: string;
  endDateError: string;
  noOfDaysError: string;
  noOfDaysErrorProducts: string;
  shopifyProducts: any;
  shopifyOrders: any;
  orderStatuses: any = [];
  selectedOrderStatus: any = [];
  selectedSyncStatus: any = [];
  sysnFulfillOrders: any = [];
  selectedFulfillStatus: any = [];
  fulfillmentStatus: any;
  orders: any = [];
  sysnOrders: any = [];
  providerStatuses: any = [];
  configurationList: any = [];
  enableSchedule: boolean = false;
  enableScheduleProducts: boolean = false;
  enableMagento: boolean = false;
  enableShopclues: boolean = false;
  enableFlipkart: boolean = false;
  enableEbay: boolean = false;
  enableShopify: boolean = false;
  enableWoocommerce: boolean = false;
  concatStatus: string = '';
  sourceOrderNoError: string = '';
  sourceOrderNumber: string = '';
  hostNamePrefix: string = '';
  statusNoError: string = '';
  status: string;
  scheduleStatusNoError: string = '';
  scheduleStatus: string;
  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, public user: User, private route: ActivatedRoute, private router: Router) {
    this.hostNamePrefix = "https://";
    this.getByStoreId(this.route.snapshot.paramMap.get('id'));
    this.orderStatuses = [
      { label: 'New', config: 'SUBMITTED' },
      { label: 'Ready to ship', config: 'READY_TO_SHIP' },
      { label: 'Exception', config: 'EXCEPTION' },
      { label: 'Cancelled', config: 'CANCELLED' },
      { label: 'Delivered', config: 'DELIVERED' },
      { label: 'On Hold', config: 'ON_HOLD' }
    ];
    this.importsdropdownList = [
      { label: 'New', value: 'SUBMITTED' },
      { label: 'Ready to ship', value: 'READY_TO_SHIP' },
      { label: 'Exception', value: 'EXCEPTION' },
      { label: 'Cancelled', value: 'CANCELLED' },
      { label: 'Delivered', value: 'DELIVERED' },
      { label: 'On Hold', value: 'ON_HOLD' }
    ];
    this.importsFulFillmentStatusList = [
      { label: 'Shipped', config: 'Shipped' },
      { label: 'Partial', config: 'Partial' },
      { label: 'Unshipped', config: 'Unshipped' }
    ];
    /*this.api.getValues("1", "ORDER_STATUS","SHIFT" ,"SHIFT").subscribe((data:any)=> {this.orderStatuses = data.tripleSetConfigDTOS;},err=> {
         this.alertService.error('Error',err);
          });*/
    this.providerStatuses = [{
      "id": 69,
      "config": "Pending",
      "orderBy": 9,
      "organizationId": 1
    }, {
      "id": 72,
      "config": "Processing",
      "orderBy": 12,
      "organizationId": 1
    }, {
      "id": 65,
      "config": "On Hold",
      "orderBy": 5,
      "organizationId": 1
    }, {
      "id": 63,
      "config": "Complete",
      "orderBy": 3,
      "organizationId": 1
    }, {
      "id": 61,
      "config": "Cancelled",
      "orderBy": 1,
      "organizationId": 1
    }];
    /*this.api.getValues("1", "ORDER_STATUS","MAGENTO" ,"MAGENTO").subscribe((data:any)=> {this.providerStatuses = data.tripleSetConfigDTOS;},err=> {
         this.alertService.error('Error',err);
          });*/
    this.api.getConfigurationsList(this.user.accountOwnerId, this.user.organizationId, this.route.snapshot.paramMap.get('id')).subscribe((data: any) => {
      this.configurationList = data.getStoreConfigResponseList;
      this.configurationList.forEach((n) => {

        if (n.syncType === 'ORDERS') {
          this.syncId = n.id;
          if (n.syncOption === 'ACTIVE') {
            this.importOrders = true;
          } else {
            this.importOrders = false;
          }
          if (n.manualSyncOption === 'ACTIVE') {
            this.manualImportsOrders = true;
          } else {
            this.manualImportsOrders = false;
          }
          if (n.scheduleOption === 'ACTIVE') {
            this.scheduleOrders = true;
          } else {
            this.scheduleOrders = false;
          }

          if (n.updateOption === 'ACTIVE') {
            this.updateOrders = true;
          } else {
            this.updateOrders = false;
          }
        }
        if (n.syncType === 'PRODUCTS') {
          this.syncProductId = n.id;
          if (n.manualSyncOption === 'ACTIVE') {
            this.manualImportsProducts = true;
          } else {
            this.manualImportsProducts = false;
          }
        }
        this.selectedItems = n.syncStatuses;
        let selectedItems: any = [];
        if (n.syncStatuses) {
          selectedItems = n.syncStatuses.split(',');
        }
        if (selectedItems.length) {
          selectedItems.forEach((s) => {
            let syncOrdStatus = s.split('=');
            this.sysnOrders.push({ label: syncOrdStatus[0], status: syncOrdStatus[1] || '' });
          });
          this.sysnOrders.forEach((s) => {
            let index = this.providerStatuses.findIndex((d) => d.config === s.label);
            if (index > -1) {
              this.selectedSyncStatus[index] = s.status;
            }
          });
        }

        let config: any = [];
        if (n.pushStatuses) {
          config = n.pushStatuses.split(',');
          this.concatStatus = n.pushStatuses;
        }
        if (config.length) {
          config.forEach((s) => {
            let order = s.split('=');
            this.orders.push({ label: order[0], status: order[1] || '' });
          });
          this.orders.forEach((s) => {
            let index = this.orderStatuses.findIndex((d) => d.config === s.label);
            if (index > -1) {
              this.selectedOrderStatus[index] = s.status;
            }
          });
        }

      });
    }, err => { console.log(err); });
  }


  ngOnInit() {
    var today = new Date().toISOString().split('T')[0];
    document.getElementById("startDateProducts").setAttribute('min', today);
    document.getElementById("endDateProducts").setAttribute('min', today);
    document.getElementById("spstartDateProducts").setAttribute('min', today);
    document.getElementById("spendDateProducts").setAttribute('min', today);
    document.getElementById("spendDate").setAttribute('min', today);
    document.getElementById("spstartDate").setAttribute('min', today);
    document.getElementById("startDate").setAttribute('min', today);
    document.getElementById("endDate").setAttribute('min', today);
    this.dropdownList = [
      'New',
      'Pending',
      'Processing',
      'Complete',
      'Closed',
      'Cancelled',
      'On Hold',
      'Payment Review'
    ];

    this.dropdownSettings = {
      singleSelection: false,

      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    this.storeManageId = this.route.snapshot.paramMap.get('id');
    if (this.storeManageId) {
      this.api.getStoreManagementById(this.storeManageId, this.user.accountOwnerId, this.user.organizationId).subscribe((data: any) => {
        this.storeManage = data;
        this.mId = this.storeManage.id;
        this.imageUrl = this.storeManage.brandImageUrl ? this.storeManage.brandImageUrl : '';
        if (this.storeManage.status === 'ACTIVE') {
          this.enableMagento = true;
          this.enableShopclues = true;
          this.enableEbay = true;
          this.enableShopify = true;
          this.enableWoocommerce = true;
          this.enableFlipkart = true;
        }
      }, err => {
        this.alertService.error('Error', err);
      });
    }

  }

  tabChange(tab) {
    this.tabClicked = tab
  }
  getByStoreId(storeId) {
    this.api.getByStoreId(this.user.accountOwnerId, this.user.organizationId, this.route.snapshot.paramMap.get('id')).subscribe((data: any) => {
      this.scheduleStores = data.getManageStoreInfoResponses;
    }, err => {
      this.alertService.error('Error', err);
    });
  }
  dateChange(startDate) {
    if (this.store.endDateProducts) {
      this.store.endDateProducts = '';
    }
    document.getElementById("endDateProducts").setAttribute('min', startDate);
  }
  dateChangeSd(startDate) {
    if (this.store.endDate) {
      this.store.endDate = '';
    }
    document.getElementById("endDate").setAttribute('min', startDate);
  }
  dateChangeSp(startDate) {
    if (this.store.eendDate) {
      this.store.eendDate = '';
    }
    document.getElementById("spendDate").setAttribute('min', startDate);
  }
  dateChangeSps(startDate) {
    if (this.store.eendDateProducts) {
      this.store.eendDateProducts = '';
    }
    document.getElementById("spendDateProducts").setAttribute('min', startDate);
  }
  dateChangeFdp(startDate) {
    if (this.endDateProducts) {
      this.endDateProducts = '';
    }
    document.getElementById("toDateProducts").setAttribute('min', startDate);
    document.getElementById("toDateProducts").setAttribute('max', moment(startDate).add(30, 'days').format("YYYY-MM-DD"));
  }
  dateChangeFd(startDate) {
    if (this.endDate) {
      this.endDate = '';
    }
    document.getElementById("toDate").setAttribute('min', startDate);
    document.getElementById("toDate").setAttribute('max', moment(startDate).add(30, 'days').format("YYYY-MM-DD"));
    if (!startDate) {
      document.getElementById("toDate").setAttribute('min', '');
      document.getElementById("toDate").setAttribute('max', '');
    }
  }
  getStoreManagement() {
    this.api.getAllStoreManagementData(this.user.accountOwnerId, "ACTIVE", this.user.organizationId).subscribe((data: any) => { this.storeManagement = data; }, err => {
      this.alertService.error('Error', err);
    });
  }
  cancelStoreDetails() {
    this.storeManagementp = 'N';
    this.statusText = "";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";
    this.statusText9 = "";
    this.statusText10 = "";
    this.statusText11 = "";
    this.statusText12 = "";
    this.statusText13 = "";
    this.statusText14 = "";
    this.statusText15 = "";
    this.statusText16 = "";
    this.statusText17 = "";
    this.statusText18 = "";
    this.storeManage.userName = "";
    this.storeManage.hostName = "";
    this.storeManage.passWord = "";
    this.storeManage.apiKey = "";
    this.storeManage.storeType = "";
    this.storeManage.version = "";
    this.storeManage.clientId = "";
    this.storeManage.devId = "";
    this.storeManage.clientSecret = "";
    this.storeManage.storePassword = "";
  }
  getAllShopcluesOrderByOrderNumber() {
    this.sourceOrderNoError = '';
    this.statusNoError = '';
    if (!this.status) {
      this.statusNoError = "Please select status";
    }
    if (!this.sourceOrderNumber) {
      this.sourceOrderNoError = "Please enter source order number";
      return;
    }
    this.g.loaderDisplay = "display";
    this.api.getAllShopcluesOrderByOrderNumber(this.user.accountOwnerId, this.sourceOrderNumber, this.storeManage.id, this.status).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.magentoOrders = data;
      if (data['code'] == 200) {
        this.status = undefined;
        this.sourceOrderNumber = '';
        this.alertService.success(data['message']);
      }
      else if (data['code'] == 400) {
        this.g.loaderDisplay = "display";
        this.alertService.error(data['message']);
      }
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }
  getAllShopcluesOrders() {
    this.startDateError = '';
    this.endDateError = '';
    this.noOfDaysError = '';
    this.statusNoError = '';
    let startDate = '';
    let endDate = '';
    this.statusText = "";
    if (!this.status) {
      this.statusNoError = "Please select status";
    }
    if (this.selectPeriodicType == 'Last Days') {
      if (!this.noOfDays) {
        this.noOfDaysError = "Please enter no of days";
        return;
      }
      startDate = moment().subtract(this.noOfDays, 'days').format("MM/DD/YYYY");
      endDate = moment().format("MM/DD/YYYY");
    }
    else {
      if (!this.startDate) {
        this.startDateError = "Please enter start date";
        return;
      }
      startDate = moment(this.startDate).format("MM/DD/YYYY")
      endDate = moment(this.endDate).format("MM/DD/YYYY");
    }
    if (endDate = 'Invalid date') {
      endDate = moment().format("MM/DD/YYYY");
      if (!moment(endDate).isSameOrAfter(startDate)) {
        endDate = moment(startDate).format("MM/DD/YYYY");
      }
    }
    this.g.loaderDisplay = "display";
    this.api.getAllOrdersFromShopClues(this.user.accountOwnerId, startDate, this.user.organizationId, this.storeManage.id, this.status, endDate).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.magentoOrders = data;
      if (data['code'] == 200) {
        this.status = undefined;
        if (this.selectPeriodicType == 'Last Days') {
          this.noOfDays = undefined;
        } else {
          this.startDate = '';
          document.getElementById("toDate").setAttribute('min', '');
          document.getElementById("toDate").setAttribute('max', '');
          this.endDate = '';
        }
        this.alertService.success(data['message']);
        //this.orderSucessMessage = data['message'];
      }
      else if (data['code'] == 400) {
        this.g.loaderDisplay = "display";
        this.alertService.error(data['message']);
      }
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  toGetShopcluesProducts() {
    this.startDateErrorProducts = '';
    this.endDateErrorProducts = '';
    this.noOfDaysErrorProducts = '';
    let startDateProducts = '';
    let endDateProducts = '';

    if (this.selectPeriodicTypeProducts == 'Last Days') {
      if (!this.noOfDaysProducts) {
        this.noOfDaysErrorProducts = "Please enter no of days";
        return;
      }
      startDateProducts = moment().subtract(this.noOfDaysProducts, 'days').format("MM/DD/YYYY");
      endDateProducts = moment().format("MM/DD/YYYY");
    }
    else {
      if (!this.startDateProducts) {
        this.startDateErrorProducts = "Please enter start date";
        return;
      }

      startDateProducts = moment(this.startDateProducts).format("MM/DD/YYYY")
      endDateProducts = moment(this.endDateProducts).format("MM/DD/YYYY");
    }
    if (endDateProducts = 'Invalid date') {
      endDateProducts = moment().format("MM/DD/YYYY");
      if (!moment(endDateProducts).isSameOrAfter(startDateProducts)) {
        endDateProducts = moment(startDateProducts).format("MM/DD/YYYY");
      }
    }
    this.g.loaderDisplay = "display";
    this.api.toGetShopcluesProducts(this.user.accountOwnerId, startDateProducts, this.storeManage.id, endDateProducts).subscribe((data: any) => {
      this.g.loaderDisplay = "";

      this.magentoProducts = data;
      if (data['code'] == 200) {
        this.startDateProducts = '';
        this.endDateProducts = '';
        this.noOfDaysProducts = undefined;
        this.alertService.success(data['message']);

        //this.productSucessMessage = data['message'];
      }
      else if (data['code'] == 400) {
        this.g.loaderDisplay = "";

        this.alertService.error(data['message']);
      }
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  toGetAllShopifyProducts() {
    this.startDateErrorProducts = '';
    this.endDateErrorProducts = '';
    this.noOfDaysErrorProducts = '';
    let startDateProducts = '';
    let endDateProducts = '';

    if (this.selectPeriodicTypeProducts == 'Last Days') {
      if (!this.noOfDaysProducts) {
        this.noOfDaysErrorProducts = "Please enter no of days";
        return;
      }
      startDateProducts = moment().subtract(this.noOfDaysProducts, 'days').format("MM/DD/YYYY");
      endDateProducts = moment().format("MM/DD/YYYY");
    }
    else {
      if (!this.startDateProducts) {
        this.startDateErrorProducts = "Please enter start date";
      }
      if (!this.endDateProducts) {
        this.endDateErrorProducts = "Please enter end date";
      }
      if (!this.startDateProducts || !this.endDateProducts) {
        return;
      }
      startDateProducts = moment(this.startDateProducts).format("MM/DD/YYYY")
      endDateProducts = moment(this.endDateProducts).format("MM/DD/YYYY");
    }

    this.g.loaderDisplay = "display";

    this.api.toGetAllShopifyProducts(this.user.accountOwnerId, startDateProducts, endDateProducts).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.shopifyProducts = data;
      if (data['code'] == 200) {
        this.alertService.success('Shopify Products', 'Product Successfully');

        //this.productSucessMessage = data['message'];
      }
      else if (data['code'] == 400) {
        this.g.loaderDisplay = "";

        this.alertService.error(data['message']);
      }
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  toGetShopifyOrders() {
    this.startDateError = '';
    this.endDateError = '';
    this.noOfDaysError = '';
    let startDate = '';
    let endDate = '';

    if (this.selectPeriodicType == 'Last Days') {
      if (!this.noOfDays) {
        this.noOfDaysError = "Please enter no of days";
        return;
      }
      startDate = moment().subtract(this.noOfDays, 'days').format("MM/DD/YYYY");
      endDate = moment().format("MM/DD/YYYY");
    }
    else {
      if (!this.startDate) {
        this.startDateError = "Please enter start date";
      }
      if (!this.endDate) {
        this.endDateError = "Please enter end date";
      }
      if (!this.startDate || !this.endDate) {
        return;
      }
      startDate = moment(this.startDate).format("MM/DD/YYYY")
      endDate = moment(this.endDate).format("MM/DD/YYYY");
    }
    this.g.loaderDisplay = "display";

    this.api.toGetShopifyOrders(this.user.accountOwnerId, startDate, endDate, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.shopifyOrders = data;
      if (data['code'] == 200) {
        this.alertService.success('Shopify Order', 'Created Successfully');

        // this.orderSucessMessage = data['message'];
      }
      else if (data['code'] == 400) {
        this.g.loaderDisplay = "";

        this.alertService.error(data['message']);
      }
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }


  submitAll() {
    let request: any = {};
    let syncType = "";
    if (this.tabClicked === 'PRODUCTS') {
      request = {
        "manualSyncOption": this.manualImportsProducts ? "ACTIVE" : "IN_ACTIVE",
        "organizationId": 1,
        "storesManagementId": this.storeManageId,
        "scheduleOption": this.scheduleProducts ? "ACTIVE" : "IN_ACTIVE",
        "syncType": this.tabClicked
      };
      if (this.syncProductId !== '') {
        request.id = this.syncProductId;
      }
    } else {
      request = {
        "manualSyncOption": this.manualImportsOrders ? "ACTIVE" : "IN_ACTIVE",
        "organizationId": 1,
        "pushStatuses": this.concatStatus,
        "storesManagementId": this.storeManageId,
        "syncOption": this.importOrders ? "ACTIVE" : "IN_ACTIVE",
        "scheduleOption": this.scheduleOrders ? "ACTIVE" : "IN_ACTIVE",
        "syncStatuses": this.selectedItems,
        "syncType": this.tabClicked,
        "updateOption": this.importOrders ? "ACTIVE" : "IN_ACTIVE"
      };
      if (this.syncId !== '') {
        request.id = this.syncId;
      }
    }


    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createStoreConfigurations', request,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          if (this.tabClicked === 'PRODUCTS') {
            this.syncProductId = data['id'] || '';
          } else {
            this.syncId = data['id'] || '';
          }
          this.alertService.success('Status', 'Submitted Successfully');

        }
      },
      );
  }
  submitSyncStatus(label, status) {
    let concatStatus = '';
    if (this.sysnOrders && this.sysnOrders.length) {
      let index = this.sysnOrders.findIndex((d) => d.label === label);
      if (index > -1) {
        this.sysnOrders[index].status = status;
      } else {
        this.sysnOrders.push({ label, status });
      }
    } else {
      this.sysnOrders.push({ label, status });
    }
    this.sysnOrders.forEach((s) => {
      if (s.label && s.status) {
        concatStatus = concatStatus + (concatStatus === '' ? '' : ',') + s.label + '=' + s.status;
      }
    });
    this.selectedItems = concatStatus;
    this.submitAll();
  }
  submitSyncFulfillStatus(label, status) {
    let concatStatus = '';
    if (this.sysnFulfillOrders && this.sysnFulfillOrders.length) {
      let index = this.sysnFulfillOrders.findIndex((d) => d.label === label);
      if (index > -1) {
        this.sysnFulfillOrders[index].status = status;
      } else {
        this.sysnFulfillOrders.push({ label, status });
      }
    } else {
      this.sysnFulfillOrders.push({ label, status });
    }
    this.sysnFulfillOrders.forEach((s) => {
      if (s.label && s.status) {
        concatStatus = concatStatus + (concatStatus === '' ? '' : ',') + s.label + '=' + s.status;
      }
    });
    this.fulfillmentStatus = concatStatus;
    this.submitAll();
  }
  submitStatus(label, status) {
    let concatStatus = '';
    if (this.orders && this.orders.length) {
      let index = this.orders.findIndex((d) => d.label === label);
      if (index > -1) {
        this.orders[index].status = status;
      } else {
        this.orders.push({ label, status });
      }
    } else {
      this.orders.push({ label, status });
    }
    this.orders.forEach((s) => {
      if (s.label && s.status) {
        concatStatus = concatStatus + (concatStatus === '' ? '' : ',') + s.label + '=' + s.status;
      }
    });
    this.concatStatus = concatStatus;
    this.submitAll();
  }
  typeChannelName() {
    this.statusText22 = "";
    if (this.storeManage.connectionName == '' || this.storeManage.connectionName === null || this.storeManage.connectionName === undefined || this.storeManage.connectionName === 'undefined') {
      this.statusText22 = 'Please enter connectionName';
    }
  }
  selectPassword() {
    this.statusText1 = "";
    if (this.storeManage.clientSecret == '' || this.storeManage.clientSecret === null || this.storeManage.clientSecret === undefined || this.storeManage.clientSecret === 'undefined') {
      this.statusText1 = 'Please enter password';
    }
  }


  showConnectBtn(type) {
    let show = false;
    if (this.storeManagement) {
      this.storeManagement.forEach((s) => {
        if (s.storeType === type) {
          show = true
        }
      });
    }
    return show;
  }
  syncProcess() {
    this.statusText29 = "";
    this.statusText30 = "";
    this.statusText31 = "";
    this.statusText32 = "";
    this.statusText33 = "";
    this.statusText34 = "";
    this.statusText35 = "";
    this.scheduleStatusNoError = "";
    if (!this.store.status) {
      this.scheduleStatusNoError = "Please select status";
    }
    if (this.store.syncType == 'PERIODICALLY') {
      if (this.store.startDate == '' || this.store.startDate === null || this.store.startDate === undefined || this.store.startDate === 'undefined') {
        this.statusText30 = 'Please select start date';

      }
      if (this.store.duration == '' || this.store.duration === null || this.store.duration === undefined || this.store.duration === 'undefined') {
        this.statusText32 = 'Please select frequency';

      }
      if (this.store.durationType == '' || this.store.durationType === null || this.store.durationType === undefined || this.store.durationType === 'undefined') {
        this.statusText33 = 'Please select duration type';

      }
      if (this.statusText30 != "" || this.statusText32 != "" || this.statusText33 != "") {
        this.g.loaderDisplay = "";
        return false;
      }
    }
    if (this.store.syncType != 'PERIODICALLY') {
      if (this.store.sstartDate == '' || this.store.sstartDate === null || this.store.sstartDate === undefined || this.store.sstartDate === 'undefined') {
        this.statusText34 = 'Please select start date';
        return false;
      }
    }
    if (this.scheduleStatusNoError) { return; }
    this.g.loaderDisplay = "display";
    let configSchedule;
    if (this.store.syncType == 'PERIODICALLY') {
      configSchedule = {
        "accountOwnerId": this.user.accountOwnerId,
        "organizationId": this.user.organizationId,
        "requestList": [
          {
            "accountOwnerId": this.user.accountOwnerId,
            "duration": this.store.duration,
            "durationType": this.store.durationType,
            "organizationId": 1,
            "syncType": this.store.syncType,
            "storeId": this.storeManage.id,
            "startDate": this.store.startDate,
            "endDate": this.store.endDate,
            "status": this.store.status
          }
        ]
      };
    }
    else {
      configSchedule = {
        "accountOwnerId": this.user.accountOwnerId,
        "organizationId": this.user.organizationId,
        "requestList": [
          {
            "accountOwnerId": this.user.accountOwnerId,
            "organizationId": 1,
            "syncType": this.store.syncType,
            "storeId": this.storeManage.id,
            "startDate": this.store.sstartDate,
            "endDate": this.store.eendDate
            //     "dates": "string",
            //   "week": "string"
          }
        ]
      }
    };
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/configureSchedulingTime', configSchedule,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          if (this.store.syncType == 'PERIODICALLY') {
            this.store.duration = '';
            this.store.durationType = '';
            this.store.startDate = '';
            this.store.endDate = '';
          } else {
            this.store.sstartDate = '';
            this.store.eendDate = '';
          }

          this.getByStoreId(this.storeManage.id);
          this.alertService.success('Schedule', 'Created Successfully');
        }
        this.sync = 'N';
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  syncProductsProcess() {
    this.errorStartDate = "";
    this.errorDuration = "";
    this.errorDurationType = "";
    this.errorSStartDate = "";
    if (this.store.syncTypes == 'PERIODICALLY') {
      if (this.store.startDateProducts == '' || this.store.startDateProducts === null || this.store.startDateProducts === undefined || this.store.startDateProducts === 'undefined') {
        this.errorStartDate = 'Please select start date';

      }
      if (this.store.durationProducts == '' || this.store.durationProducts === null || this.store.durationProducts === undefined || this.store.durationProducts === 'undefined') {
        this.errorDuration = 'Please select duration';

      }
      if (this.store.durationTypeProducts == '' || this.store.durationTypeProducts === null || this.store.durationTypeProducts === undefined || this.store.durationTypeProducts === 'undefined') {
        this.errorDurationType = 'Please select duration type';

      }
      if (this.errorStartDate != "" || this.errorDuration != "" || this.errorDurationType != "") {
        this.g.loaderDisplay = "";
        return false;
      }
    }
    if (this.store.syncTypes != 'PERIODICALLY') {
      if (this.store.sstartDateProducts == '' || this.store.sstartDateProducts === null || this.store.sstartDateProducts === undefined || this.store.sstartDateProducts === 'undefined') {
        this.errorSStartDate = 'Please select start date';
        return false;
      }
    }

    this.g.loaderDisplay = "display";
    let configSchedule;
    if (this.store.syncTypes == 'PERIODICALLY') {
      configSchedule = {
        "accountOwnerId": this.user.accountOwnerId,
        "organizationId": this.user.organizationId,
        "requestList": [
          {
            "accountOwnerId": this.user.accountOwnerId,
            "duration": this.store.durationProducts,
            "durationType": this.store.durationTypeProducts,
            "organizationId": 1,
            "syncType": this.store.syncTypes,
            "storeId": this.storeManage.id,
            "startDate": this.store.startDateProducts,
            "endDate": this.store.endDateDateProducts,
          }
        ]
      };
    }
    else {
      configSchedule = {
        "accountOwnerId": this.user.accountOwnerId,
        "organizationId": this.user.organizationId,
        "requestList": [
          {
            "accountOwnerId": this.user.accountOwnerId,
            "organizationId": 1,
            "syncType": this.store.syncTypes,
            "storeId": this.storeManage.id,
            "startDate": this.store.sstartDateProducts,
            "endDate": this.store.eendDateDateProducts
            //     "dates": "string",
            //   "week": "string"
          }
        ]
      }
    };
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/configureSchedulingTime', configSchedule,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.getByStoreId(this.storeManage.id);
          this.alertService.success('Schedule', 'Created Successfully');
        }
        this.sync = 'N';
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  typeClientSecret() {
    this.statusText11 = "";
    if (this.storeManage.clientSecret == '' || this.storeManage.clientSecret === null || this.storeManage.clientSecret === undefined || this.storeManage.clientSecret === 'undefined') {
      this.statusText11 = 'Please enter client secret';
    }
  }

  typeUserName() {
    this.statusText2 = "";
    if (this.storeManage.userName == '' || this.storeManage.userName === null || this.storeManage.userName === undefined || this.storeManage.userName === 'undefined') {
      this.statusText2 = 'Please enter user name';
    }
  }

  typePassword() {
    this.statusText1 = "";
    if (this.storeManage.storePassword == '' || this.storeManage.storePassword === null || this.storeManage.storePassword === undefined || this.storeManage.storePassword === 'undefined') {
      this.statusText1 = 'Please enter password';
    }
  }
  typeClientId() {
    this.statusText6 = "";
    if (this.storeManage.clientId == '' || this.storeManage.clientId === null || this.storeManage.clientId === undefined || this.storeManage.clientId === 'undefined') {
      this.statusText6 = 'Please enter client Id';
    }
  }


  submit() {

    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/toStoreMagentoCredentials', {
      "accountOwnerId": this.user.accountOwnerId,
      //"userName":  this.storeManage.userName,
      "connectionName": this.storeManage.connectionName,
      "organizationId": 1,
      "clientSecret": this.storeManage.clientSecret,
      //"password":this.storeManage.storePassword,
      "storeType": "SHOPCLUES",
      "clientId": this.storeManage.clientId,
      "brandImageUrl": this.imageUrl,
      "storeId": this.storeManage.id
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shopclues', 'Submitted Successfully');
          this.storeDetails = 'N';
          this.storeManagementp = 'N';
        } else if (data['code'] == null) {
          this.alertService.success('Shopify', 'No Orders to Sync');
          this.storeDetails = 'N';
          this.storeManagementp = 'N';
        }
        else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  loadImage(event) {
    this.imageUrl = event.target.files[0];
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }
  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.uploadImage = null;
    this.imageUrl = null;
    this.errorMessage = "";
  }
  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }

  removeStore(index) {
    this.deleteApiPop = 'Y';
    this.index = index;
  }

  closePopup() {
    this.deleteApiPop = 'n';
  }
  deleteSchedule(id, index) {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/deleteSchedule', {
      "accountOwnerId": this.user.accountOwnerId,
      "id": id,
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.scheduleStores.splice(index, 1);
          this.alertService.success('', 'Schedule Deleted Successfully');
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
  editPopup(index) {
    this.editApiPop = 'Y';
    this.index = index;
    this.scheduleStore = this.scheduleStores[index];
  }

  closeEditPopup() {
    this.editApiPop = 'n';
  }
  editSchedule() {
    /*this.statusText36 ="";
    this.statusText37 ="";
    this.statusText38 ="";
    this.statusText39 ="";

    if (this.scheduleStore.syncType == 'PERIODICALLY'){
          if (this.scheduleStore.startDate == '' || this.scheduleStore.startDate === null || this.scheduleStore.startDate === undefined || this.scheduleStore.startDate === 'undefined') {
                        this.statusText36 = 'Please select start date';

                }
          if (this.scheduleStore.duration == '' || this.scheduleStore.duration === null || this.scheduleStore.duration === undefined || this.scheduleStore.duration === 'undefined') {
                        this.statusText37 = 'Please select duration';

                }
          if (this.scheduleStore.durationType == '' || this.scheduleStore.durationType === null || this.scheduleStore.durationType === undefined || this.scheduleStore.durationType === 'undefined') {
                        this.statusText38 = 'Please select duration type';

                }
    if (this.statusText36 != "" ||this.statusText37 != "" ||this.statusText38 != "") {
           this.g.loaderDisplay = "";
           return false;
        }
    }
    if (this.scheduleStore.syncType != 'PERIODICALLY'){
          if (this.scheduleStore.sstartDate == '' || this.scheduleStore.sstartDate === null || this.scheduleStore.sstartDate === undefined || this.scheduleStore.sstartDate === 'undefined') {
                        this.statusText39 = 'Please select start date';
           return false;
                }
    }

        this.g.loaderDisplay = "display";
        let configSchedule;
        if(this.scheduleStore.syncType == 'PERIODICALLY'){
     configSchedule = {
      "accountOwnerId": this.scheduleStore.accountOwnerId,
      "organizationId": this.user.organizationId,
      "requestList": [
        {
      "id" :this.scheduleStore.id,
      "syncType" : this.scheduleStore.syncType,
      "syncFrequency" : null,
      "lastSyncDate" : "28-Oct-2020",
      "specificType" : null,
      "dates" : null,
      "week" : null,
      "duration" : this.scheduleStore.duration,
      "durationType" : this.scheduleStore.durationType,
      "startDate" : this.scheduleStore.startDate,
      "endDate" : this.scheduleStore.endDate,
      "storeId" : this.scheduleStore.storeId,
      "storeConfigId" : this.scheduleStore.storeConfigId,
      "accountOwnerId" : this.scheduleStore.accountOwnerId,
      "organizationId" : 1
    }
      ]
    }
            }
            else{
            configSchedule = {
      "accountOwnerId": this.user.accountOwnerId,
      "organizationId": this.user.organizationId,
      "requestList": [
        {
            "accountOwnerId": this.user.accountOwnerId,
             "organizationId": 1,
             "syncType": this.scheduleStore.syncType,
             "storeId": this.scheduleStore.id,
             "startDate": this.scheduleStore.sstartDate,
             "endDate": this.scheduleStore.eendDate,
            "dates": "string",
            "duration": "string",
            "durationType": "string",
            "id": this.scheduleStore.id,
            "lastSyncDate": "2020-10-12T13:03:35.563Z",
            "organizationId": 0,
            "specificType": "string",
            "startDate": "string",
            "storeConfigId": 0,
            "syncFrequency": "string",
            "syncType": "string",
            "week": "string"
        }
      ]
         }
        };


        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));
        this.http.post(environment.apiUrl + 'api/updateSchedule',configSchedule,
          {headers: header1}).subscribe(data => {
           if(data['code'] == "200"){
                      this.alertService.success('','Schedule Updated Successfully');
                    }else{
                        this.alertService.error(data['message']);
                    }
    this.g.loaderDisplay = "";
          },
          (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          });*/
  }

  verify() {
    this.statusText22 = "";
    this.statusText11 = "";
    //this.statusText1= "";
    this.statusText6 = "";
    // this.statusText2= "";
    if (this.storeManage.connectionName == '' || this.storeManage.connectionName === null || this.storeManage.connectionName === undefined || this.storeManage.connectionName === 'undefined') {
      this.statusText22 = 'Please enter channel name';
    }
    if (this.storeManage.clientSecret == '' || this.storeManage.clientSecret === null || this.storeManage.clientSecret === undefined || this.storeManage.clientSecret === 'undefined') {
      this.statusText11 = 'Please enter client secret';
    }
    /*
          if (this.storeManage.userName == '' || this.storeManage.userName === null || this.storeManage.userName === undefined || this.storeManage.userName === 'undefined') {
            this.statusText2 = 'Please enter user name';
          }
    */

    /*      if (this.storeManage.storePassword == '' || this.storeManage.storePassword === null || this.storeManage.storePassword === undefined || this.storeManage.storePassword === 'undefined') {
            this.statusText1 = 'Please enter password';
          }*/
    if (this.storeManage.clientId == '' || this.storeManage.clientId === null || this.storeManage.clientId === undefined || this.storeManage.clientId === 'undefined') {
      this.statusText6 = 'Please enter client Id';
    }

    if (this.statusText22 != "" || this.statusText11 != "" || this.statusText6 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyShopCluesConnection/', {
      //"username":  this.storeManage.userName,
      "client_id": this.storeManage.clientId,
      //"password": this.storeManage.storePassword,
      "client_secret": this.storeManage.clientSecret
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shopclues', 'Connected Successfully');
          this.submit();
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  openDetailSection(sectionName) {
    this.tabActive = sectionName;
    if (this.manualImportsOrders) {
      this.selectPeriodicType = "Date Range";
    } else {
      this.selectPeriodicType = "";
    }
    if (this.manualImportsProducts) {
      this.selectPeriodicTypeProducts = "Date Ranges";
    } else {
      this.selectPeriodicTypeProducts = "";
    }
    if (this.scheduleProducts) {
      this.store.syncTypes = "PERIODICALY";
    } else {
      this.store.syncTypes = "";
    }
    if (this.scheduleOrders) {
      this.store.syncType = "PERIODICALLY";
    } else {
      this.store.syncType = "";
    }
  }

  selectDateType() {
    this.startDateError = '';
    this.startDateErrorProducts = '';
    this.endDateError = '';
    this.endDateErrorProducts = '';
    this.noOfDaysError = '';
    this.noOfDaysErrorProducts = '';
    if (this.selectPeriodicType === 'Date Range') {
      this.noOfDays = null;
    } else {
      this.startDate = '';
      this.endDate = '';
    }
  }
  selectDateTypeProducts() {
    this.startDateErrorProducts = '';
    this.endDateErrorProducts = '';
    this.noOfDaysErrorProducts = '';
    if (this.selectPeriodicTypeProducts === 'Date Ranges') {
      this.noOfDaysProducts = null;
    } else {
      this.startDateProducts = '';
      this.endDateProducts = '';
    }
  }
}
